import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CatalogPermissionUserConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import messages from './messages'
import { useAssignSecondaryCategoriesToUserModel } from '../../models'

interface UseAssignSecondaryCategoriesToUserPresenterOptions {
  user: CatalogPermissionUserConfig
  onSuccess?: () => void
}

export const useAssignSecondaryCategoriesToUserPresenter = ({
  user,
  onSuccess,
}: UseAssignSecondaryCategoriesToUserPresenterOptions) => {
  const intl = useProcurifyIntl()
  const { mutate, isLoading, isOptionsLoading, secondaryCategoryOptions } =
    useAssignSecondaryCategoriesToUserModel()

  const handleSave = (selectedSecondaryCategoryIds: number[]) => {
    mutate(
      { userId: user.id, secondaryCategoryIds: selectedSecondaryCategoryIds },
      {
        onSuccess: () => {
          toast.success({
            title: intl.formatMessage(messages.successTitle),
            children: intl.formatMessage(messages.successMessage),
          })
          onSuccess?.()
        },
        onError: (error) => {
          toast.error({
            title: intl.formatMessage(messages.errorTitle),
            children:
              getMessageFromError(error) ||
              intl.formatMessage(messages.errorMessage),
          })
        },
      }
    )
  }

  return {
    secondaryCategoryOptions,
    isSaving: isLoading,
    isLoading: isOptionsLoading,
    handleSave,
  }
}
